import { PdpDesktopDetailRow } from './PdpDesktopDetailRow';
import type { ProductStoneDetailsInput } from '@/features/pdp/utils/productDetailStones';
import {
  getSolitaireSummaryLabel,
  hasSolitaireDetails,
} from '@/features/pdp/utils/productDetailStones';

const WEIGHT_VARIATION_TEXT =
  'The final invoice amount will be adjusted in case of variation in weight.';

export function PdpDesktopSolitaireDetails({
  onInfoIconClick,
  ...input
}: ProductStoneDetailsInput & { onInfoIconClick?: (label: string) => void }) {
  if (!hasSolitaireDetails(input)) {
    return null;
  }

  const summaryLabel = getSolitaireSummaryLabel(input);

  return (
    <>
      {summaryLabel ? <PdpDesktopDetailRow label="Stone Type" value={summaryLabel} /> : null}
      {input.solitaireTotalNoOfStones ? (
        <PdpDesktopDetailRow label="Count" value={input.solitaireTotalNoOfStones} />
      ) : null}
      {input.solitaireClarity ? (
        <PdpDesktopDetailRow label="Clarity" value={input.solitaireClarity} />
      ) : null}
      {input.solitaireColor ? (
        <PdpDesktopDetailRow label="Color" value={input.solitaireColor} />
      ) : null}
      {input.solitaireCarat ? (
        <PdpDesktopDetailRow
          label="Solitaires Weight"
          value={`${input.solitaireCarat} Ct`}
          tooltip={WEIGHT_VARIATION_TEXT}
          onInfoIconClick={onInfoIconClick}
        />
      ) : null}
    </>
  );
}
